// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"fc7b625148eb1bc0ddfc","655":"0b3b3e57d637fa5f08a9"}[chunkId] + ".js";
};